@if (showInfo) {
  <section class="info-wrapper">
    <section class="info-container">
      <i class="icon-remarks info-icon" [ngClass]="iconClass"></i>
      <p class="info-text">{{text}}</p>
    </section>
  </section>
}